import createBbox from '@turf/bbox'
import { Feature } from '@turf/helpers'
import { FeatureCollection } from 'geojson'
import { ExpressionType } from '~/prix/types/expression'

/**
 * Extrai da expressão os valores usados nos filtros de acordo com a propriedade.
 * @param expression Expression usada na requisição.
 * @param property Propriedade a ter seus valores buscados.
 * @returns Array dos valores encontrados na propriedade selecionada
 */
export function extractPropertyFromExpression(
  expression: ExpressionType | undefined,
  property: string,
): { label: string; value: string }[] {
  if (!expression) return []

  const extractedTargets = new Set<{ label: string; value: string }>()

  /**
   * Percorre a expression, buscando os portes mesmo que aninhadas
   */
  function walk(expression: any) {
    if (!expression || typeof expression !== 'object') return

    if (expression.kind === 'binary') {
      if (
        expression.left?.kind === 'property' &&
        expression.left?.property === property &&
        expression.right?.kind === 'literal' &&
        expression.operator === '='
      ) {
        if (expression.operator === '=') {
          extractedTargets.add({
            label: String(expression.right.label),
            value: String(expression.right.value),
          })
        }
      }
      walk(expression.left)
      walk(expression.right)
    }
  }

  walk(expression)
  return Array.from(extractedTargets)
}

/**
 * Calcula a posição, bounds, e zoom do mapa de acordo com a FeatureCollection.
 */
export function fetchMapPosition(featureCollection: FeatureCollection) {
  const filterValidFeatures = (item: Feature) => {
    if (item.properties.shouldIgnorePosition) {
      return false
    } else {
      return true
    }
  }
  const validFeatureCollections = featureCollection.features.filter(filterValidFeatures)
  const bbox = createBbox({
    type: 'FeatureCollection',
    features: validFeatureCollections,
  })
  const bounds: google.maps.LatLngBoundsLiteral = {
    west: bbox[0] - 0.001,
    south: bbox[1] - 0.001,
    east: bbox[2] + 0.001,
    north: bbox[3] + 0.001,
  }

  // If 3D and small area, focus on center
  const focusOnCenter =
    false && bounds.east - bounds.west < 0.05 && bounds.north - bounds.south < 0.05
  if (focusOnCenter) {
    const center = {
      lat: (bounds.north + bounds.south) / 2,
      lng: (bounds.east + bounds.west) / 2,
    }
    return { center, zoom: 16 }
  }

  return { bounds }
}
